/* eslint-disable react/prop-types */
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import moment from "moment";

const NotificationItem = ({ notification, onClick, onDelete }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        borderLeft: notification.is_read ? "2px solid transparent" : "2px solid",
        borderLeftColor: notification.is_read ? "transparent" : "primary.main",
        px: 1.5,
        py: 1,
        cursor: "pointer",
        borderRadius: 1,
        "&:hover": {
          backgroundColor: "action.hover",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: notification.is_read ? 500 : 700 }}>
            {notification.title}
          </Typography>
          <Tooltip title={notification.message || ""} placement="top" arrow>
            <Typography variant="body2" color="text.secondary" noWrap>
              {notification.message}
            </Typography>
          </Tooltip>
          <Typography variant="caption" color="text.secondary">
            {moment(notification.created_on).fromNow()}
          </Typography>
        </Box>
        <IconButton
          size="small"
          aria-label="Delete notification"
          onClick={(event) => {
            event.stopPropagation();
            onDelete();
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default NotificationItem;
